import { createApp } from 'vue';
import './index.css';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
// 引入全局API请求器
import api from '../http';
// 引入微信JSSDK
import wechat from './utils/wechat';

const app = createApp(App);

app.use(router);
app.use(i18n);

// 将API挂载到全局属性，支持proxy.$api访问
app.config.globalProperties.$api = api;
// 将微信JSSDK挂载到全局属性，支持proxy.$wechat访问
app.config.globalProperties.$wechat = wechat;

app.mount('#root');